import type { FixPositionEffectCode, FixTimeInForceCode } from '@model/DxTrade.types'

export const FAVORITES = 'Favorites' as const

export const FILTER_TAGS = ['All', FAVORITES, 'Forex', 'Commodities', 'Crypto', 'Indices'] as const

export const TAG_TO_ASSET_CLASS: Record<string, string> = {
  Commodities: 'Commodities',
  Crypto: 'Cryptocurrencies',
  Indices: 'Indices',
}

export const TAG_TO_TYPE: Record<string, string> = {
  Forex: 'FOREX',
}

export const FIX_POSITION_EFFECT: Record<string, FixPositionEffectCode> = {
  OPEN: 'O',
  CLOSE: 'C',
} as const

export const FIX_TIME_IN_FORCE: Record<string, FixTimeInForceCode> = {
  DAY: '1',
  GOOD_TILL_DATE: '6',
} as const

export const DXTRADE_POSITION_EFFECT = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
} as const

export type DxtradePositionEffect =
  (typeof DXTRADE_POSITION_EFFECT)[keyof typeof DXTRADE_POSITION_EFFECT]

export const DXTRADE_TIME_IN_FORCE = {
  GOOD_TILL_CANCEL: 'GTC',
  GOOD_TILL_DATE: 'GTD',
} as const

export const WIDGET_TYPE = {
  ORDER: 'order',
  MARKET: 'market',
} as const
